import React, { useState } from "react";
import { TextField, Button, Container, Grid } from "@mui/material";

interface FormData {
  ClientName: string;
  Date_of_birth: string;
  Gender: string;
  NDIS_Plan_Start_Date: string;
  NDIS_Number: string;
  StaffName: string;
  ShiftNotes: string;
}

const ShiftNotesForm: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    ClientName: "Josh",
    Date_of_birth: "01/20/1995",
    Gender: "Male",
    NDIS_Plan_Start_Date: "01/20/1995",
    NDIS_Number: "0994H",
    StaffName: "Israel",
    ShiftNotes: "Notes",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Handle form submission, you can send data to backend or do any other operations here
    console.log(formData);
  };

  return (
    <Container maxWidth="sm" sx={{backgroundColor: 'purple'}}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Client Name"
              name="ClientName"
              value={formData.ClientName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Date of Birth"
              name="Date_of_birth"
              value={formData.Date_of_birth}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Gender"
              name="Gender"
              value={formData.Gender}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="NDIS Plan Start Date"
              name="NDIS_Plan_Start_Date"
              value={formData.NDIS_Plan_Start_Date}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="NDIS Number"
              name="NDIS_Number"
              value={formData.NDIS_Number}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Staff Name"
              name="StaffName"
              value={formData.StaffName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Shift Notes"
              name="ShiftNotes"
              value={formData.ShiftNotes}
              onChange={handleChange}
              multiline
              rows={4} // Adjust the number of rows as per your preference
            />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default ShiftNotesForm;
